import { put } from './requests'

const resourcePath = 'onboarding'

export function updateOnboarding (onboarding) {
  return put(resourcePath, { onboarding })
}
